import axiosInstance from "../auth/FetchInterceptor";
import {
  REPORT_ORDER_STATS,
  REPORT_ORDER_DAILY_REVENUE,
  REPORT_ORDER_DAILY_COUNT,
  REPORT_ORDER_REVENUE_BY_AIRPORT,
  REPORT_ORDER_DETAIL_BY_AIRPORT,
  REPORT_CUSTOMER_STATS,
  REPORT_CUSTOMER_DAILY_NEW,
  REPORT_CUSTOMER_RETENTION,
  REPORT_CUSTOMER_TOP_SPENDING,
  REPORT_DRIVER_VEHICLE_STATS,
  REPORT_DRIVER_VEHICLE_TOP_DRIVERS,
  REPORT_DRIVER_VEHICLE_TOP_VEHICLES,
  REPORT_DRIVER_VEHICLE_RANKING,
  REPORT_VEHICLE_EXPENSE_SUMMARY,
  REPORT_VEHICLE_EXPENSE_PIE_CHART,
  REPORT_VEHICLE_EXPENSE_LINE_CHART,
  REPORT_VEHICLE_EXPENSE_TABLE,
  REPORT_DASHBOARD_STATS,
  REPORT_DASHBOARD_UNASSIGNED_TRIPS,
  REPORT_DASHBOARD_UPCOMING_TRIPS,
  REPORT_DASHBOARD_DRIVER_STATUS,
  REPORT_DASHBOARD_ACTIVE_TRIPS,
  REPORT_ORDER_EXPORT,
  REPORT_CUSTOMER_EXPORT,
  REPORT_DRIVER_EXPORT,
  REPORT_VEHICLE_EXPORT,
} from "constants/ApiConstant";

const ReportService = {};

//ORDER
ReportService.reportOrderStats = function (data) {
  return axiosInstance.post(REPORT_ORDER_STATS, data);
};
ReportService.reportOrderDailyRevenue = function (data) {
  return axiosInstance.post(REPORT_ORDER_DAILY_REVENUE, data);
};
ReportService.reportOrderDailyCount = function (data) {
  return axiosInstance.post(REPORT_ORDER_DAILY_COUNT, data);
};
ReportService.reportOrderRevenueByAirport = function (data) {
  return axiosInstance.post(REPORT_ORDER_REVENUE_BY_AIRPORT, data);
};
ReportService.reportOrderDetailByAirport = function (data) {
  return axiosInstance.post(REPORT_ORDER_DETAIL_BY_AIRPORT, data);
};
ReportService.reportOrderExportExcel = function (data) {
  return axiosInstance.post(REPORT_ORDER_EXPORT, data, {
    headers: {
      "Content-Type": "application/json",
    },
    responseType: "blob",
  });
};

//CUSTOMER
ReportService.reportCustomerStats = function (data) {
  return axiosInstance.post(REPORT_CUSTOMER_STATS, data);
};
ReportService.reportCustomerDailyNew = function (data) {
  return axiosInstance.post(REPORT_CUSTOMER_DAILY_NEW, data);
};
ReportService.reportCustomerRetention = function (data) {
  return axiosInstance.post(REPORT_CUSTOMER_RETENTION, data);
};
ReportService.reportCustomerTopSpending = function (data) {
  return axiosInstance.post(REPORT_CUSTOMER_TOP_SPENDING, data);
};
ReportService.reportCustomerExportExcel = function (data) {
  return axiosInstance.post(REPORT_CUSTOMER_EXPORT, data, {
    headers: {
      "Content-Type": "application/json",
    },
    responseType: "blob",
  });
};

//DRIVER VEHICLE
ReportService.reportDriverVehicleStats = function (data) {
  return axiosInstance.post(REPORT_DRIVER_VEHICLE_STATS, data);
};
ReportService.reportDriverVehicleTopDrivers = function (data) {
  return axiosInstance.post(REPORT_DRIVER_VEHICLE_TOP_DRIVERS, data);
};
ReportService.reportDriverVehicleTopVehicles = function (data) {
  return axiosInstance.post(REPORT_DRIVER_VEHICLE_TOP_VEHICLES, data);
};
ReportService.reportDriverVehicleRanking = function (data) {
  return axiosInstance.post(REPORT_DRIVER_VEHICLE_RANKING, data);
};
ReportService.reportDriverVehicleExportExcel = function (data) {
  return axiosInstance.post(REPORT_DRIVER_EXPORT, data, {
    headers: {
      "Content-Type": "application/json",
    },
    responseType: "blob",
  });
};

//VEHICLE EXPENSE
ReportService.reportVehicleExpenseSummary = function (data) {
  return axiosInstance.post(REPORT_VEHICLE_EXPENSE_SUMMARY, data);
};
ReportService.reportVehicleExpensePieChart = function (data) {
  return axiosInstance.post(REPORT_VEHICLE_EXPENSE_PIE_CHART, data);
};
ReportService.reportVehicleExpenseLineChart = function (data) {
  return axiosInstance.post(REPORT_VEHICLE_EXPENSE_LINE_CHART, data);
};
ReportService.reportVehicleExpenseTable = function (data) {
  return axiosInstance.post(REPORT_VEHICLE_EXPENSE_TABLE, data);
};
ReportService.reportVehicleExportExcel = function (data) {
  return axiosInstance.post(REPORT_VEHICLE_EXPORT, data, {
    headers: {
      "Content-Type": "application/json",
    },
    responseType: "blob",
  });
};

//DASHBOARD
ReportService.reportDashboardStats = function (data) {
  return axiosInstance.get(REPORT_DASHBOARD_STATS, data);
};
ReportService.reportDashboardUnassignedTrips = function (data) {
  return axiosInstance.post(REPORT_DASHBOARD_UNASSIGNED_TRIPS, data);
};
ReportService.reportDashboardUpcomingTrips = function (data) {
  return axiosInstance.get(REPORT_DASHBOARD_UPCOMING_TRIPS, data);
};
ReportService.reportDashboardDriverStatus = function (data) {
  return axiosInstance.get(REPORT_DASHBOARD_DRIVER_STATUS, data);
};
ReportService.reportDashboardActiveTrips = function (data) {
  return axiosInstance.get(REPORT_DASHBOARD_ACTIVE_TRIPS, data);
};

export default ReportService;
